import React from "react";

const Services = () => {
  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2>Our Core Services</h2>
          <p>Comprehensive industrial solutions and technical services for your business needs</p>
        </div>
        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">
              <img src="/Images/Icons/Equipment Supply.png" alt="Machinery & Equipment Supply icon" />
            </div>
            <h3>Machinery & Equipment Supply</h3>
            <p>
              Wide range of industrial, engineering, and educational machinery including workshop machines,
              fabrication equipment, construction machinery, and laboratory setups for ITIs and Polytechnic colleges.
            </p>
            <ul className="service-features">
              <li>Workshop Machines (Lathe, Milling, Drilling, etc.)</li>
              <li>Fabrication & Welding Equipment</li>
              <li>Construction Machinery & Tools</li>
              <li>Electrical & Mechanical Laboratory Setups</li>
              <li>CNC, Hydraulic & Pneumatic Training Machines</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-icon">
              <img src="/Images/Icons/Fire & Safety Division.png" alt="Fire & Safety Division icon" />
            </div>
            <h3>Fire & Safety Division</h3>
            <p>
              Complete fire protection solutions from design to commissioning for factories, hospitals,
              commercial complexes, and government institutions with full compliance to NFPA, BIS, and NBC standards.
            </p>
            <ul className="service-features">
              <li>Fire Alarm & Detection Systems</li>
              <li>Fire Hydrant and Sprinkler Systems</li>
              <li>Automatic Suppression Systems</li>
              <li>Portable & Trolley-Mounted Extinguishers</li>
              <li>AMC & System Testing Services</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-icon">
              <img src="/Images/Icons/Government Supply.png" alt="Government & Tender Supply icon" />
            </div>
            <h3>Government & Tender Supply</h3>
            <p>
              Authorized vendor for government departments and educational institutions with extensive
              experience in tender participation and execution for various departments and smart city projects.
            </p>
            <ul className="service-features">
              <li>ITI & Polytechnic Institute Setups</li>
              <li>PWD / Municipal Department Supplies</li>
              <li>Educational Training Kits</li>
              <li>Defence / Police / Fire Department Equipment</li>
              <li>Smart City Projects & Civic Utilities</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-icon">
              <img src="/Images/Icons/Technical Services.png" alt="Engineering & Technical Services icon" />
            </div>
            <h3>Engineering & Technical Services</h3>
            <p>
              Complete technical services including installation, commissioning, maintenance, and training
              programs with our team of ITI, Diploma, and B.E. professionals.
            </p>
            <ul className="service-features">
              <li>Installation & Commissioning</li>
              <li>Preventive & Breakdown Maintenance</li>
              <li>Calibration & Testing Services</li>
              <li>Site Layout Planning & Engineering Drawings</li>
              <li>Turnkey Project Execution</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-icon">
              <img src="/Images/Icons/Wholesale Distribution.png" alt="Retail & Wholesale Distribution icon" />
            </div>
            <h3>Retail & Wholesale Distribution</h3>
            <p>
              Comprehensive distribution network for workshop tools, industrial consumables, fire safety
              accessories, and safety PPE with competitive pricing and pan-India delivery.
            </p>
            <ul className="service-features">
              <li>Workshop Tools & Spare Parts</li>
              <li>Industrial Consumables</li>
              <li>Fire Safety Accessories & Equipment</li>
              <li>Lubricants, Bearings & Fasteners</li>
              <li>Safety PPE & Protective Equipment</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;